/*
BLOG CONSTANT for tags
Type 0 is for general purpose
Type 1 for day school
Type 2 for pre school
Type 3 for boarding school
 */

const maxShowBlog = 10;

const blogArr = [
    {
        'type': 0,
        'json': []
    },

    {
        'type': 1,
        'json': [
            {
                id: 100,
                url: 'day-school'
            }
        ]
    },


    {
        'type': 2,
        'json': [
            {
                id: 101,
                url: 'pre-school'
            }
        ]
    },

    {
        'type': 3,
        'json': [

            {
                id: 84,
                url: 'boarding'
            },
            {
                id: 85,
                url: 'boarding-schools'
            },
            {
                id: 86,
                url: 'boarding-schools-admission'
            }
        ]
    },

];


